import { z } from 'zod';

export const processZod = z.object({
  process_id: z.string(),
  log_name: z.string(),
  datatype: z.string(),
  start_time: z.number(),
  end_time: z.number(),
  status: z.string(),
  created_at: z.string(), // format: date-time
});
export type Process = z.infer<typeof processZod>;
export const processArrayZod = z.array(processZod);

export const dataRequestZod = z.object({
  request_id: z.string(),
  description: z.string(),
  status: z.string(),
  user_email: z.string(),
  producer: z.string(),
  created_at: z.string(), // format: date-time
  processes: z.array(processZod),
});
export type DataRequest = z.infer<typeof dataRequestZod>;
export const dataRequestArrayZod = z.array(dataRequestZod);

// Schemas from openapi.json
export const dataTypeResponseZod = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
});
export const dataTypeResponseArrayZod = z.array(dataTypeResponseZod);
export type DataTypeResponse = z.infer<typeof dataTypeResponseZod>;

const processCreateZod = z.object({
  log_name: z.string(),
  datatype: z.string(),
  start_time: z.number().int(),
  end_time: z.number().int(),
});
export type ProcessCreate = z.infer<typeof processCreateZod>;

export const triggerRequestCreateZod = z.object({
  producer: z.string(),
  user_email: z.string().email(),
  description: z.string().max(255),
  processes: z.array(processCreateZod),
});
export type TriggerRequestCreate = z.infer<typeof triggerRequestCreateZod>;

export const triggerRequestResponseZod = z.object({
  request_id: z.string(),
  status: z.string(),
  message: z.string(),
  created_at: z.string(), // Is string in openapi, but format: date-time. Zod doesn't have datetime yet.
});
export type TriggerRequestResponse = z.infer<typeof triggerRequestResponseZod>;

// Deprecated: This was the old flat structure. New structure is DataRequest with nested Processes.
// Kept for reference if needed for other API calls, but not for the data requests table.
export const processResponseZod = z.object({
  process_id: z.string(),
  request_id: z.string(),
  log_name: z.string(),
  datatype: z.string(),
  start_time: z.number(),
  end_time: z.number(),
  status: z.string(),
  status_updated_at: z.string(), // format: date-time
  created_at: z.string(), // format: date-time
  user_email: z.string(),
  producer: z.string(),
});
export type ProcessResponse = z.infer<typeof processResponseZod>;
export const processResponseArrayZod = z.array(processResponseZod);
